import React, { useContext } from "react";
import HeaderDefaultToPage from "../../../../components/Common/headerDefaultToPage";
import { DF_OT0023Context } from "../context";

export default function GridHeader() {
  const { idParceiro } = useContext(DF_OT0023Context);

  return (
    <HeaderDefaultToPage 
      title="Detalhes do Agendamento" 
      goBack={false} 
    />
  );
}